import Homepage from "../pages/website/Home"
import RequestContactForm from "../pages/website/RequestContactForm"
import Dashboard from "../pages/webapp/Dashboard"

import ServicesPage from "../pages/website/Services"
import AboutPage from "../pages/website/About"
import ClientLogin from "../pages/website/ClientLogin"
import ContactForm from "../pages/website/GeneralContactForm"
import ApplicationsManager from "../pages/webapp/ApplicationsManager"
import PrivateRoute from "@utils/PrivateRoute.client"
import PropertyManager from "@pages/webapp/PropertyManager"
import RequestApplicationForm from "@pages/website/RequestApplicationForm"
import GestionLocativePortneuf from "@pages/website/GestionLocativePortneuf"
import GestionChaletsPortneuf from "@pages/website/GestionChaletsPortneuf"
import GuideProprietairesPortneuf from "@pages/website/GuideProprietairesPortneuf"
import ReglementationImmeublesPortneuf from "@pages/website/Blog/ReglementationImmeublesPortneuf"
import PreparerPlexHiverNeuville from "@pages/website/Blog/PreparerPlexHiverNeuville"
import OptimiserChaletsLocatifs from "@pages/website/Blog/OptimiserChaletsLocatifs"
import PrivacyPolicy from "@pages/website/PrivacyPolicy/index.server"
import TermsOfUse from "@pages/website/TermsOfUse/index.server"
import NotFound from "@pages/website/NotFound"
import Requests from "@pages/webapp/Requests"
import NewServiceRequest from "@pages/webapp/NewServiceRequest"
import Reports from "@pages/webapp/Reports"
import Help from "@pages/webapp/Help"
import Access from "@pages/webapp/Access"
import PasswordAccess from "@pages/website/PasswordAccess"
import Inbox from "@pages/webapp/Inbox"

const routes = [
  {
    path: "/",
    element: <Homepage />,
  },
  {
    path: "/services-gestion-immobiliere",
    element: <ServicesPage />,
  },
  {
    path: "/gestion-locative-portneuf",
    element: <GestionLocativePortneuf />,
  },
  {
    path: "/gestion-chalets-condos-portneuf",
    element: <GestionChaletsPortneuf />,
  },
  {
    path: "/guide-proprietaires-portneuf",
    element: <GuideProprietairesPortneuf />,
  },
  {
    path: "/blog/reglementation-immeubles-portneuf",
    element: <ReglementationImmeublesPortneuf />,
  },
  {
    path: "/blog/preparer-plex-hiver-neuville",
    element: <PreparerPlexHiverNeuville />,
  },
  {
    path: "/blog/optimiser-chalets-locatifs",
    element: <OptimiserChaletsLocatifs />,
  },
  {
    path: "/faire-une-demande",
    element: <RequestContactForm />,
  },
  {
    path: "/demande-de-location",
    element: <RequestApplicationForm />,
  },
  {
    path: "/nous-contacter",
    element: <ContactForm />,
  },
  {
    path: "/a-propos",
    element: <AboutPage />,
  },
  {
    path: "/politique-de-confidentialite",
    element: <PrivacyPolicy />,
  },
  {
    path: "/conditions-utilisation",
    element: <TermsOfUse />,
  },
  {
    path: "/se-connecter",
    element: <ClientLogin />,
  },
  {
    path: "/mot-de-passe-oublie",
    element: <PasswordAccess mode="forgot" />,
  },
  {
    path: "/definir-mot-de-passe",
    element: <PasswordAccess mode="reset" />,
  },
  {
    path: "/app",
    element: <PrivateRoute />,
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
    ],
  },
  {
    path: "/app/demandes",
    element: <PrivateRoute />,
    children: [{ path: "", element: <Requests /> }],
  },
  {
    path: "/app/nouvelle-demande",
    element: <PrivateRoute />,
    children: [{ path: "", element: <NewServiceRequest /> }],
  },
  {
    path: "/app/rapports",
    element: <PrivateRoute requiredRoles={["PROPRIETAIRE", "ADMIN", "USER"]} />,
    children: [{ path: "", element: <Reports /> }],
  },
  {
    path: "/app/aide",
    element: <PrivateRoute />,
    children: [{ path: "", element: <Help /> }],
  },
  {
    path: "/app/reception",
    element: <PrivateRoute requiredRole="ADMIN" />,
    children: [{ path: "", element: <Inbox /> }],
  },
  {
    path: "/app/acces",
    element: <PrivateRoute requiredRole="ADMIN" />,
    children: [{ path: "", element: <Access /> }],
  },
  {
    path: "/app/gestion-des-candidatures",
    element: <PrivateRoute requiredRole="ADMIN" />,
    children: [
      {
        path: "",
        element: <ApplicationsManager />,
      },
    ],
  },
  {
    path: "/app/gestion-des-proprietes",
    element: <PrivateRoute requiredRole="ADMIN" />,
    children: [
      {
        path: "",
        element: <PropertyManager />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]

export default routes
